import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

const RequestModal = ({
  show,
  handleClose,
  values,
  description,
  setDescription,
}) => {
  useEffect(() => {
    if (show) {
      setDescription(values?.description);
    } else {
      setDescription("");
    }
  }, [show]);
  const handleSubmit = (e) => {
    e.preventDefault();
    handleClose();
  };
  return (
    <Modal show={show} centered className="request_modal" onHide={handleClose}>
      <Modal.Body>
        <div className="desc_box">
          <form onSubmit={handleSubmit}>
            <label htmlFor="desc">Enter your desired commission </label>
            <textarea
              id="desc"
              name="desc"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
            {description?.length < 10 ? <div className="error">
              Description must be greater than 10
            </div> : description?.length > 100 ? <div className="error">
              Description must be less than 100
            </div>: null}
            <button type="submit" className="submit_btn" disabled={description?.length < 10 || description?.length > 100}>
              Submit
            </button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RequestModal;
